import { api } from '@/boot/axios'

const KDS_TOKEN_KEY = 'kds_access_token'

export function getKdsToken () {
  if (typeof window === 'undefined') return null
  return window.localStorage.getItem(KDS_TOKEN_KEY)
}

export function setKdsToken (token) {
  window.localStorage.setItem(KDS_TOKEN_KEY, token)
}

export function clearKdsToken () {
  window.localStorage.removeItem(KDS_TOKEN_KEY)
}

export async function exchangePairingCode ({ code, deviceName, device_name: deviceNameSnake }) {
  const name = deviceName ?? deviceNameSnake
  const { data } = await api.post('/kds/pairing/exchange', {
    code,
    device_name: name
  })
  return data
}

export async function fetchKdsQueue () {
  const token = getKdsToken()
  const { data } = await api.get('/kds/queue', {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  })
  return data
}

export async function updateKdsFulfillment (saleId, fulfillmentStatus) {
  const token = getKdsToken()
  const { data } = await api.patch(`/kds/sales/${saleId}/fulfillment`, {
    fulfillment_status: fulfillmentStatus
  }, {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  })
  return data
}

export async function listKdsDevices () {
  const { data } = await api.get('/kds/devices')
  return data
}

export async function createKdsPairingCode (locationId) {
  const { data } = await api.post('/kds/pairing-codes', { location_id: locationId })
  return data
}

export async function revokeKdsDevice (deviceId) {
  const { data } = await api.delete(`/kds/devices/${deviceId}`)
  return data
}
